module.exports = __webpack_public_path__ + "img/52.fd280c40.jpg";